import React, {
  FC,
  HTMLAttributes,
  useState,
  Suspense,
  lazy,
  useEffect,
} from "react";
import { Button, Menu, MenuItem, Tab, Tabs } from "@mui/material";
import { styled } from "@mui/material/styles";
import ChargesManagement from "../charges-management";
import TaxesManagenent from "../taxes-management";
import ItemScheduleManagement from "../item-schedule-management";
import { useParams } from "react-router-dom";
import history from "../../../history";
import { CATALOG_PAGE_ROUTE } from "../../../data/routes-constants";
import { BULK_TYPE } from "../../../data/constants";
import AccountsManagement from "../accounts-management";
import BrandsManagement from "../brands-management";
import MenusManagement from "../menus-management";
import { isSourcePos } from "../../../helpers/common-helper";

const BaseMenuManagement = lazy(() => import("../base-menu-management")),
  ChannelMenuManagement = lazy(() => import("../channel-menu-management")),
  ManageGalleryComponent = lazy(() => import("../gallery-component")),
  DiscountsManagement = lazy(() => import("../discounts-management")),
  AddOnsManagement = lazy(() => import("../add-ons-management")),
  BulkUploadComponent = lazy(() => import("../bulk-upload"));

const AntTabs = styled(Tabs)({
  borderBottom: "1px solid #e8e8e8",
  "& .MuiTabs-indicator": {
    backgroundColor: "#000000",
    height: "4px",
  },
});

const CatalogueDashboard: FC<HTMLAttributes<HTMLDivElement>> = (props: any) => {
  const { tabID } = useParams();
  const HEADER_TABS_MAP: any = {
    baseMenu: "Base Menu",
    channelMenu: "Channel Menu",
    addOns: "Add-ons",
  };
  const BULK_ACTIONS_LIST = [
    { id: "bulk_image", text: "Bulk Image Update" },
    { id: "bulk_item", text: "Bulk Item Upload" },
    { id: "bulk_price", text: "Bulk Price Update" },
    { id: BULK_TYPE.bulk_item_setting, text: "Update Items Settings" },
    { id: 'bulk_add_ons', text: "Bulk Add-Ons Upload" },
    { id: 'bulk_add_ons_update', text: "Bulk Add-Ons Update" },
    { id: BULK_TYPE.bulk_item_delete, text: "Bulk Item Delete" },
  ];

  const MORE_SETTINGS_OPTIONS_MAP: any = {
    gallery: "Gallery",
    charges: "Charges",
    taxes: "Taxes",
    discounts: "Discounts",
    itemSchedules: "Item Schedules",
    menu: "Menu",
    brands: "Brands",
    accounts: "Accounts",
  };

  const [selectedTab, setSelectedTab] = useState<string>("");
  const [anchorMoreSettingsEl, setAnchorMoreSettingsEl] =
    React.useState<null | HTMLElement>(null);
  const openMoreSettings = Boolean(anchorMoreSettingsEl);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedBulkAction, setSelctedBulkAction] = useState<any>({
    open: false,
    id: "",
  });
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLElement>,
    index: number
  ) => {
    setSelctedBulkAction({ id: BULK_ACTIONS_LIST[index].id, open: true });
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    setSelectedTab(tabID || Object.keys(HEADER_TABS_MAP)[0]);
  }, [tabID]);

  const handleMoreSettingsCtaClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setAnchorMoreSettingsEl(event.currentTarget);
  };
  const handleMoreSettingsMenuClose = () => {
    setAnchorMoreSettingsEl(null);
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: any) => {
    setSelectedTab(newValue);
    history.push(CATALOG_PAGE_ROUTE + `/${newValue}`);
  };

  const onMoreSettingsOptionClick = (e: any, newValue: string) => {
    handleMoreSettingsMenuClose();
    setSelectedTab(newValue);
    history.push(CATALOG_PAGE_ROUTE + `/${newValue}`);
  };

  function renderHeaderTabs(): React.JSX.Element {
    return (
      <AntTabs
        value={selectedTab}
        onChange={handleTabChange}
        aria-label="catalogue-tab"
        className={`fixed top-[85px] ${isSourcePos()?"left-0":"left-[96px]"} px-24 sm:left-[0px] z-[11] min-h-[58px]
          w-full bg-white shadow-[0px_3px_6px_#0000000D] border-[1px] border-[#F0F0F0]
        `}
      >
        {Object.keys(HEADER_TABS_MAP).map((tabId: string) => (
          <Tab
            label={HEADER_TABS_MAP[tabId]}
            key={tabId}
            value={tabId}
            className={`${
              tabId === selectedTab
                ? "font-semibold text-[#000]"
                : "font-normal text-[#7F7F7F]"
            } capitalize text-18 leading-none`}
          />
        ))}

        <div className="flex items-center justify-center">
          <Button
            id="more-settings-button"
            aria-controls={openMoreSettings ? "more-settings-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={openMoreSettings ? "true" : undefined}
            // variant="contained"
            disableElevation
            onClick={handleMoreSettingsCtaClick}
            endIcon={
              <div
                className={`rista-sprite ${
                  openMoreSettings
                    ? "ic-dropdown-arrow-up"
                    : "ic-dropdown-arrow-down"
                }`}
              ></div>
            }
            className={`more-settings-button capitalize text-18 leading-none py-[8px] pl-[16px] pr-[11px] rounded-[8px] hover:border-black hover:bg-[#F0F0F0] ${
              MORE_SETTINGS_OPTIONS_MAP[selectedTab]
                ? "font-semibold text-[#000]"
                : "font-normal text-[#7F7F7F]"
            } `}
          >
            {MORE_SETTINGS_OPTIONS_MAP[selectedTab] || "More Settings"}
          </Button>
          <Menu
            id="more-settings-menu"
            anchorEl={anchorMoreSettingsEl}
            open={openMoreSettings}
            onClose={handleMoreSettingsMenuClose}
            MenuListProps={{
              "aria-labelledby": "more-settings-button",
            }}
            PaperProps={{
              style: {
                width: "200px",
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            {Object.keys(MORE_SETTINGS_OPTIONS_MAP).map(
              (optionId: string, index: number) => {
                return (
                  <MenuItem
                    onClick={(e) => onMoreSettingsOptionClick(e, optionId)}
                    key={index}
                  >
                    {MORE_SETTINGS_OPTIONS_MAP[optionId]}
                  </MenuItem>
                );
              }
            )}
          </Menu>
        </div>
      </AntTabs>
    );
  }

  function renderBulkAction(): React.JSX.Element {
    return (
      <>
        <button
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          className={`fixed right-[50px] bg-white top-[93px] z-[11] flex items-center rounded-[8px] border-[1px] border-[#D6D6D6] ${
            open ? "border-black text-[#000]" : "border-[#D6D6D6] text-[#343434]/70"
          } hover:border-black hover:text-[#000] text-16 leading-none
          px-16 py-8`}
        >
          Bulk Action
          <div className="rista-sprite ic-dropdown ml-8 mb-2"></div>
        </button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {BULK_ACTIONS_LIST.map(
            (item: { id: string; text: string }, index: number) => (
              <MenuItem
                key={index}
                onClick={(event) => handleMenuItemClick(event, index)}
              >
                {item.text}
              </MenuItem>
            )
          )}
        </Menu>
      </>
    );
  }

  function renderTabPanels(): React.JSX.Element {
    switch (selectedTab) {
      case "baseMenu":
        return (
          <Suspense fallback={""}>
            <BaseMenuManagement></BaseMenuManagement>
          </Suspense>
        );
      case "channelMenu":
        return (
          <Suspense fallback={""}>
            <ChannelMenuManagement></ChannelMenuManagement>
          </Suspense>
        );
      case "addOns":
        return (
          <Suspense fallback={""}>
            <AddOnsManagement></AddOnsManagement>
          </Suspense>
        );
      case "gallery":
        return (
          <Suspense fallback={""}>
            <ManageGalleryComponent />
          </Suspense>
        );
      case "discounts":
        return (
          <Suspense fallback={""}>
            <DiscountsManagement />
          </Suspense>
        );
      case "charges":
        return (
          <Suspense fallback={""}>
            <ChargesManagement />
          </Suspense>
        );
      case "taxes":
        return (
          <Suspense fallback={""}>
            <TaxesManagenent />
          </Suspense>
        );
      case "itemSchedules":
        return (
          <Suspense fallback={""}>
            <ItemScheduleManagement />
          </Suspense>
        );
      case "menu":
        return (
          <Suspense fallback={""}>
            <MenusManagement />
          </Suspense>
        );
      case "brands":
        return (
          <Suspense fallback={""}>
            <BrandsManagement />
          </Suspense>
        );
      case "accounts":
        return (
          <Suspense fallback={""}>
            <AccountsManagement />
          </Suspense>
        );
      default:
        return <div></div>;
    }
  }

  return (
    <section>
      {renderHeaderTabs()}
      {renderBulkAction()}
      <section className="cms-body pt-56 h-[calc(100vh-85px)] overflow-hidden">
        {renderTabPanels()}
      </section>
      {selectedBulkAction.open && (
        <Suspense fallback={""}>
          <BulkUploadComponent
            onModalClose={() => setSelctedBulkAction({ id: "", open: false })}
            bulkType={selectedBulkAction.id}
          ></BulkUploadComponent>
        </Suspense>
      )}
    </section>
  );
};

export default CatalogueDashboard;
